module.exports = function() {
  return new Worker(__webpack_public_path__ + "687e508969ff36f20cdc.worker.js");
};